import { api } from "@/api/client";
import type {
  ConnectionCreate,
  ConnectionUpdate,
  OneCConnectionView,
} from "@/types/api";

export async function listConnections(): Promise<OneCConnectionView[]> {
  const { data } = await api.get<OneCConnectionView[]>("/connections");
  return data;
}

export async function createConnection(
  payload: ConnectionCreate,
): Promise<OneCConnectionView> {
  const { data } = await api.post<OneCConnectionView>("/connections", payload);
  return data;
}

export async function updateConnection(
  id: string,
  payload: ConnectionUpdate,
): Promise<OneCConnectionView> {
  const { data } = await api.put<OneCConnectionView>(
    `/connections/${id}`,
    payload,
  );
  return data;
}

export async function deleteConnection(id: string): Promise<void> {
  await api.delete(`/connections/${id}`);
}

export async function testConnection(
  id: string,
): Promise<{ ok: boolean; detail: string }> {
  const { data } = await api.post<{ ok: boolean; detail: string }>(
    `/connections/${id}/test`,
  );
  return data;
}
